import { BuildNode, NodeStates, RadioFieldNode } from "../../build/types";
import { useInteractionStates } from "../../hooks/useInteractionStates";
import { formatTestId } from "../../utils/format";
import { getCompoundStyle, getStateStyleForBuilder, getStylesFromInteractiveStates } from "../helpers";

interface RadioOptionProps {
    node: BuildNode;
    label: string;
    value: string;
    selected?: boolean;
    onChange?: () => void;
    builder?: boolean;
    nodeState?: NodeStates;
    disabled?: boolean;
}

const RadioOption = ({ node, label, value, selected, onChange, builder, nodeState, disabled }: RadioOptionProps) => {
    const rNode = node as RadioFieldNode;
    const { stateManager, radioStyle } = rNode;
    const { setElement, states } = useInteractionStates<HTMLLabelElement>();

    if (builder) {
        const customInputStyle = getCompoundStyle({
            otherStyle: radioStyle,
            stateStyle: getStateStyleForBuilder(stateManager, nodeState, "radioStyle")
        });

        return (
            <label>
                <input type="radio" value={value} disabled data-testid={formatTestId("builder-radio-field", label)} />
                <div className="custom-radio-input" style={customInputStyle}>
                    <p>{label}</p>
                </div>
            </label>
        );
    } else {
        const extraStates = (
            disabled || selected ? [selected && NodeStates.SELECTED, disabled && NodeStates.DISABLED].filter(Boolean) : undefined
        ) as NodeStates[];

        const customInputStyle = getStylesFromInteractiveStates({
            states,
            defaultStyle: radioStyle,
            stateManager,
            paths: ["radioStyle"],
            extraStates
        });

        return (
            <label ref={setElement}>
                <input type="radio" value={value} checked={selected} onChange={onChange} disabled={disabled} data-testid={formatTestId("builder-radio-field", label)} />
                <div className="custom-radio-input" style={customInputStyle}>
                    <p>{label}</p>
                </div>
            </label>
        );
    }
};

export default RadioOption;
